import { pendingNavRequestAtom } from '@/atoms/sideNavAtoms';
import {
  appendCheckpoint,
  getActiveTrackings,
  TrackingKey,
} from '@heidi/runtime/performance';
import { useAtomValue } from 'jotai';
import { useEffect } from 'react';

const KEY = TrackingKey.APP_NAV_MENU_SWITCH;
const CHECKPOINT = 'feedback_paint_opportunity';

/** A separate checkpoint for the loading feedback, not workspace arrival.
 * Double rAF allows a paint between callbacks; it cannot prove compositor output.
 * No timeout: a suspended WebView has not had a paint opportunity yet. */
export function useNavigationFeedbackCheckpoint() {
  // Repeated clicks to the same href still replace the request and tracking span.
  useAtomValue(pendingNavRequestAtom);
  const instanceId = getActiveTrackings().get(KEY)?.instanceId;
  useEffect(() => {
    if (instanceId === undefined) return;
    let frame = requestAnimationFrame(() => {
      frame = requestAnimationFrame(() => {
        const entry = getActiveTrackings().get(KEY);
        if (entry?.instanceId !== instanceId) return;
        if (entry.checkpoints.some(({ name }) => name === CHECKPOINT)) return;
        appendCheckpoint({ key: KEY, checkpointName: CHECKPOINT });
      });
    });
    return () => cancelAnimationFrame(frame);
  }, [instanceId]);
}
